export const mockImgCover = (index) =>
  `/static/mock-images/covers/cover_${index}.jpg`;
export const mockImgProduct = (index) =>
  `/static/mock-images/products/product_${index}.jpg`;
export const mockImgAvatar = (index) =>
  `/static/mock-images/avatars/avatar_${index}.jpg`;
export const mockImgPlaceholder = (index) =>
  `/static/mock-images/placeholder/placeholder_${index}.png`;
export const mockAvatar = "/static/mock-images/avatars/avatar_image.jpg";
export const mockAvatar1 = "/static/mock-images/avatars/avatar_image_1.jpg";
export const mockAvatar2 = "/static/mock-images/avatars/avatar_image_2.jpg";
export const mockAvatar3 = "/static/mock-images/avatars/avatar_image_3.jpg";

export const loginImage = "/static/auth-images/login.jpg";

export const lang = (lng) => `/assets/locales/{{lng}}/translation.json`;
